import React from 'react';
import { type Driver } from '@hero/schema';
import { useTranslation } from 'react-i18next';
import { useMyOrdersListApi } from '@hero/api-hooks';
import { SharedList } from '../../../app/List/List';
import { OrderCard } from '../../Order/Card/OrderCard';

export interface DriverOrdersTabProps {
  driver: Driver;
}

export function DriverOrdersTab({ driver }: DriverOrdersTabProps) {
  const { t } = useTranslation(['m-driver']);

  // Orders assigned to this Driver doc (`Order.driver._id`), scoped by
  // tenant visibility via `getMyOrders`. `as_carrier` further narrows
  // to orders where the viewing org is the seller / executor.
  const ordersQuery = useMyOrdersListApi({ driverId: driver._id, lens: 'as_carrier' });

  return (
    <div className="flex flex-col gap-3 p-5">
      <SharedList
        query={ordersQuery}
        emptyMessage={t('drawer.no_orders')}
        className="gap-3"
        renderItem={order => <OrderCard order={order} displayForUser="carrier" />}
      />
    </div>
  );
}
